import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ApolloProvider } from '@apollo/client';
import BookService from './BookService';
import { Routes, Route, Navigate } from 'react-router-dom';
import client from './graphql/apolloClient';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import RefundPolicy from './pages/RefundPolicy';
import DeleteAccountVendor from './pages/DeleteAccountVendor';
import DeleteAccountCustomer from './pages/DeleteAccountCustomer';

const App: React.FC = () => {
  useEffect(() => {
    // Fix mobile viewport height issue
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
    
    setVH();
    window.addEventListener('resize', setVH);
    window.addEventListener('orientationchange', setVH);
    
    return () => {
      window.removeEventListener('resize', setVH);
      window.removeEventListener('orientationchange', setVH);
    };
  }, []);

  const handleDownloadClick = () => {
    const userAgent = navigator.userAgent || navigator.vendor;
    
    // Detect iOS
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      // Replace with your actual App Store URL
      window.open('https://apps.apple.com/app/saloonify/id6736915133', '_blank');
    }
    // Detect Android
    else if (/android/i.test(userAgent)) {
      // Replace with your actual Play Store URL
      window.open('https://play.google.com/store/apps/details?id=com.saloonify.app', '_blank');
    }
    // Desktop or other devices - default to Play Store
    else {
      window.open('https://play.google.com/store/apps/details?id=com.saloonify.app', '_blank');
    }
  };

  return (
    <ApolloProvider client={client}>
      <AppContainer>
        <MainContent>
          <Routes>
            <Route path="/" element={<Navigate to="/book/81" replace />} />
            <Route path="/book/:salonId" element={<BookService />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/termsandconditions" element={<TermsAndConditions />} />
            <Route path="/refundpolicy" element={<RefundPolicy />} />
            <Route path="/deletetaccountvendor" element={<DeleteAccountVendor />} />
            <Route path="/deleteaccountcustomer" element={<DeleteAccountCustomer />} />
          </Routes>
        </MainContent>
        <Footer>
          <FooterText>
            powered by Saloonify{' '}
            <DownloadLink onClick={handleDownloadClick}>DOWNLOAD NOW</DownloadLink>
          </FooterText>
        </Footer>
      </AppContainer>
    </ApolloProvider>
  );
};

const AppContainer = styled.div`
  height: 100vh;
  height: 100dvh; /* Dynamic viewport height for mobile */
  width: 100vw;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  
  /* Fallback for older browsers */
  @supports not (height: 100dvh) {
    height: 100vh;
  }
  
  /* Mobile specific adjustments */
  @media (max-width: 768px) {
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
  }
`;

const MainContent = styled.div`
  flex: 1;
  overflow-y: auto;
  background: white;
`;

const Footer = styled.footer`
  padding: 16px 20px;
  text-align: center;
  background: white;
  flex-shrink: 0;
`;

const FooterText = styled.p`
  font-family: 'Hanken Grotesk', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #666666;
  margin: 0;
`;

const DownloadLink = styled.span`
  font-family: 'Hanken Grotesk', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  text-transform: uppercase;
  text-decoration: underline;
  text-decoration-style: solid;
  color: #B02E2F;
  cursor: pointer;
  
  &:hover {
    opacity: 0.8;
  }
`;

export default App;
